import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

axios.defaults.timeout = 30000

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/ticket/v3/cms/page`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const ticket3PageApi = {
  getSlaTime: (request) => {
    const { params } = request

    const url = `/agent-sla-time`
    return instance().get(url, {
      params
    })
  },
  putSlaTime: (request) => {
    const { data } = request

    const url = `/agent-sla-time`
    return instance().put(url, data)
  },
  getWrapUpRoute: (request) => {
    const { params } = request

    const url = `/wrap-up-route`
    return instance().get(url, {
      params
    })
  },
  postWrapUpRoute: (request) => {
    const { data } = request

    const url = `/wrap-up-route`
    return instance().post(url, data)
  },
  getCloseByBotTime: (request) => {
    const { params } = request

    const url = `/close-by-bot-time`
    return instance().get(url, {
      params
    })
  },
  putCloseByBotTime: (request) => {
    const { data } = request

    const url = `/close-by-bot-time`
    return instance().put(url, data)
  },
  deleteWrapUp: (request) => {
    const { data } = request
    // {
    //     "page_id": "212669041930795",
    //     "id": 1
    // }

    const url = `/wrap-up-route`
    return instance().delete(url, {
      data
    })
  },
  putTicketConfig: (request) => {
    const { data } = request

    const url = `/ticket-config`
    return instance().put(url, data)
  },
  getAdminFollowUpConfig: (request) => {
    const { params } = request

    const url = `/admin-follow-up-config`
    return instance().get(url, { params })
  },
  postAdminFollowUpConfig: (request) => {
    const { data } = request

    const url = `/admin-follow-up-config`
    return instance().post(url, data)
  }
}

export default ticket3PageApi



// WEBPACK FOOTER //
// ./src/api/ticket3/page.js